import HorizontalLine from "./HorizontalLine";
const Achievements = () => {
  return (
    <div className="mx-60 w-6/12 font-custom text-white">
      <HorizontalLine />
      <p className="text-5xl">Achievements</p>
      <ul className="p-4 m-4 list-disc text-xl">
        <li>Solved more than 200 questions on leetcode</li>
        <li>5★ on HackerRank</li>
        <li>Secured a gpa of 7.8</li>
        <li>Vice President @LiteraryClub</li>
      </ul>
      <HorizontalLine />
    </div>
  );
}
export default Achievements;
